import { DefaultIntlFormatValues } from '@ratehub/base-ui';

import COMMON_MESSAGES from '../definitions/Messages';
import FooterDefaultIntlFormatValues from '../definitions/FooterDefaultIntlFormatValues';
import getInterestRateTextFromCardInfo from './getInterestRateTextFromCardInfo';


function getInterestAndMinimumIncomeColumns({
    purchaseInterest,
    cashAdvanceInterest,
    balanceTransferInterest,

    minimumIncome,
    minimumCreditScore,

    intl,
}) {
    return [
        getInterestRateTextFromCardInfo({
            purchaseInterest,
            cashAdvanceInterest,
            balanceTransferInterest,
            intl,
        }),

        intl.formatMessage(COMMON_MESSAGES.cardFooterMinimumCreditIncome, {
            ...DefaultIntlFormatValues,
            ...FooterDefaultIntlFormatValues,
            minimumIncome,
            minimumCreditScore,
        }),
    ];
}

export default getInterestAndMinimumIncomeColumns;
